import { useSelector } from 'react-redux';
import { Action } from 'redux';
import { RootState } from '.';
import User from '../model/User';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const PERMISSIONS_SUCCESS = 'PERMISSIONS_SUCCESS';

const initialState: AuthenticationState = {
    loggedIn: false    
};

export function successLoginAction(user: User): LoginAction {
    return {
        type: LOGIN_SUCCESS,
        payload: {
            user,
            loggedIn: true
        }
    };
}

export function logoutAction(): LogoutAction {
    return {
        type: LOGOUT,
        payload: {
            user: undefined,
            loggedIn: false
        }
    }
}

export interface AuthenticationAction extends Action {
    payload?: AuthenticationState
}

export interface LoginAction extends AuthenticationAction {
    type: typeof LOGIN_SUCCESS
}

export interface LogoutAction extends AuthenticationAction {
    type: typeof LOGOUT
}

export interface AuthenticationState {
    loggedIn: boolean;
    user?: User;
}

export function mapAuthenticationStateToProps(state: RootState) {
    return state.authentication;
}

export function useAuthentication(): AuthenticationState {
    return useSelector((root: RootState) => root.authentication);
}

export function authenticationReducer(state = initialState, action: AuthenticationAction): AuthenticationState {
    const { type, payload } = action;
    switch (type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                user: payload?.user,
                loggedIn: true
            };
        case LOGOUT:
            return {
                ...state,
                user: undefined,
                loggedIn: false,
            };
        default:
            return state;
    }
}

